import imgblack_ from "./images/black.png"
import imgblue_ from "./images/blue.png"
import imgred_ from "./images/red.png"
import imggrey_ from "./images/grey.png"

import imgwin_ from "./images/Win.png";
import imggameover_ from "./images/GameOver.png";


export const imgblack = new Image();
imgblack.src = imgblack_;
export const imgblue = new Image();
imgblue.src = imgblue_;
export const imgred = new Image();
imgred.src = imgred_;
export const imggrey = new Image();
imggrey.src = imggrey_;


export const imgwin = new Image();
imgwin.src = imgwin_;
export const imggameover = new Image();
imggameover.src = imggameover_;